import React from 'react'

import PropTypes from 'prop-types'
import { equals } from 'ramda'
import { connect } from 'react-redux'

import { operationRunKlarnaManageMonthlyOperation } from '../../duck/operations'
import selectors from '../../duck/selectors'
import PreferencesComponent from './Preferences.component'

const PreferencesContainer: React.FC<any> = ({
  monthlySubscriptionStatus,
  manageMonthlyOperationToken,
  runKlarnaManageMonthlyOperation,
}) => {
  const handleOnChange = (): any => {
    runKlarnaManageMonthlyOperation(manageMonthlyOperationToken)
  }

  const handleOnClick = (): any => {
    runKlarnaManageMonthlyOperation(manageMonthlyOperationToken)
  }
  return manageMonthlyOperationToken ? (
    <PreferencesComponent
      isChecked={equals('ACTIVE', monthlySubscriptionStatus)}
      onChange={handleOnChange}
      onClick={handleOnClick}
    />
  ) : null
}

PreferencesContainer.propTypes = {
  monthlySubscriptionStatus: PropTypes.string,
  manageMonthlyOperationToken: PropTypes.string,
}

const mapDispatchToProps = (dispatch): any => {
  const runKlarnaManageMonthlyOperation = (token): any =>
    dispatch(operationRunKlarnaManageMonthlyOperation(token))

  return {
    runKlarnaManageMonthlyOperation,
  }
}

const mapStateToProps = (state): any => {
  return {
    monthlySubscriptionStatus: selectors.getMonthlySubscriptionStatus(state),
    manageMonthlyOperationToken: selectors.getManageMonthlyOperationToken(state),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreferencesContainer)
